var React = require('react');

function IcBigChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8.334 20 8-8-8-8L7 5.333 13.668 12 7 18.667 8.334 20z","fill":"currentColor"}));
}

IcBigChevronRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcBigChevronRight;

IcBigChevronRight.default = IcBigChevronRight;
